import ParkhubLogo from '../../assets/parkhub-organization-logo.svg';
import './Landing.scss';
import React, { Component, Fragment } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getOrganizations } from '../../actions/organizations.action';
import { clearAllFilters } from '../../actions/filter.action';
import * as routes from '../../constants/routes';
import { setDialogVisibility } from '../../actions/dialog.action';
import { setVisibility } from '../../actions/wizard.action';
import {
  LotsGarages,
  People,
  Organizations,
  OrganizationsTree,
  TabNavigation
} from '../../components/';
import { Header } from '@parkhub/parkhub-ui';
import { signOut } from '../../utils';

class LandingPage extends Component {
  componentDidMount() {
    if (this.props.location.pathname === '/') {
      this.props.history.push('/organizations');
    }
  }

  show = (data) => {
    this.props.setVisibility(data, true);
  };

  hide = () => {
    this.props.setVisibility({ data: null, title: null, editData: null }, false);
  };

  showDisable = (data) => {
    this.props.setDialogVisibility({ data, visibility: true });
  };

  hideDisable = () => {
    this.props.setDialogVisibility({ data: null, visibility: false });
  };

  render() {
    const actions = {
      hide: this.hide,
      show: this.show,
      hideDisable: this.hideDisable,
      showDisable: this.showDisable
    };

    const tabNavConfig = [
      {
        name: 'Organizations',
        path: routes.ORGANIZATIONS
      },
      {
        name: 'People',
        path: routes.PEOPLE
      },
      {
        name: 'Lots/Garages',
        path: routes.LOTS_GARAGES
      },
      {
        name: 'Organizations Tree',
        path: routes.ORGANIZATIONS_TREE,
        target: '_blank'
      }
    ];

    return (
      <Fragment>
        {this.props.authUser &&
          <Fragment>
            <Header
              authUser={this.props.authUser}
              signOut={() => signOut()}
              logoSrc={ParkhubLogo}
              logoWidth={260}
              appMenuActive
              backgroundColor="#6200EE"
              buttonColor="#FFFFFF"
              logoClick={() => this.props.history.push(routes.ROOT)}
            >
              <TabNavigation navConfig={tabNavConfig} defaultTab={location.pathname.split('/')[1]} />
            </Header>
            <main id="landing">
              <div className="wrapper">
                <div className="row center-xs">
                  <div className="col-xs-9">
                    <Switch>
                      <Route path={routes.PEOPLE} render={() => <People  {...this.props} actions={actions} />} />
                      <Route path={routes.ORGANIZATIONS} render={() => <Organizations {...this.props} actions={actions} />} />
                      <Route path={routes.ORGANIZATIONS_TREE} render={() => <OrganizationsTree {...this.props} actions={actions} />} />
                      <Route path={routes.LOTS_GARAGES} render={() => <LotsGarages {...this.props} actions={actions} />} />
                      <Redirect to={routes.ORGANIZATIONS} />
                    </Switch>
                  </div>
                </div>
              </div>
            </main>
          </Fragment>
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.session.authUser
});

export default withRouter(connect(mapStateToProps, {
  getOrganizations,
  clearAllFilters,
  setVisibility,
  setDialogVisibility
})(LandingPage));



// WEBPACK FOOTER //
// ./src/containers/Landing/Landing.jsx